import React, {FunctionComponent, useState} from "react";
import {
    IppodromItem,
} from "/src/domain/challenges/ChallengeProtocolData";
import makeStyles from "@mui/styles/makeStyles";
import {theme} from "/src/assets/theme";
import {Collapse, Grid, Link} from "@mui/material";
import ChallengeButton from "/src/ui/challengeProtocol/ChallengeButton";
import {ParticipantArrow} from "/src/ui/shared/challengeProtocol/Arrow";
import cs from "classnames";
import {trimName} from "/src/domain/shared/trimName";
import {ParticipantInfo} from "/src/ui/challengeProtocol/record/ParticipantInfo";
import {links} from "/src/domain/shared/links";
import {useTranslation} from "react-i18next";

const crownIcon = require('/src/assets/icons/crown.svg')

export type IppodromRecordViewProps = {
    item: IppodromItem,
    className?: string,
}

export const IppodromRecordView: FunctionComponent<IppodromRecordViewProps> = ({item, className}) => {
    const [isExpanded, expand] = useState(false);
    const classes = useStyles();
    const {t} = useTranslation();

    return (
        <div onClick={() => {
            expand(!isExpanded)
        }} className={classes.container}>
            <Grid
                container
                component={ChallengeButton}
                className={classes.container}
                alignItems="center"
            >
                <Grid
                    item container xs={11} spacing={1}>
                    <Grid item container xs={1} className={classes.cell}>
                        <ParticipantArrow
                            rotate={isExpanded}
                        />
                    </Grid>
                    <Grid item xs={1} container justifyContent="center" style={{paddingLeft: 0}}
                          className={classes.cell}>
                        {item.place + 1}
                    </Grid>
                    <Grid item xs={8} className={cs(classes.cell, classes.centeredRow)}>
                        <ParticipantInfo participant={item.participant} />
                    </Grid>
                    <Grid item container xs={2} justifyContent="flex-end" className={classes.cell}>
                        {item.totalScore}
                    </Grid>
                </Grid>
            </Grid>
            <Collapse in={isExpanded}>
                <div className={classes.race}>
                    <div className={classes.parametersBlock}>
                        <div className={classes.parametersMore}>
                            <Grid container>
                                <Grid item xs={5}>
                                    {t('ownScore')}
                                </Grid>
                                <Grid item xs={7} className={classes.parameterValue}>
                                    {item.ownScore}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={5}>
                                    {t('capitanScore')}
                                </Grid>
                                <Grid item xs={7} className={classes.parameterValue}>
                                    {item.capitanScore}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={5}>
                                    {t('teamScore')}
                                </Grid>
                                <Grid item xs={7} className={classes.parameterValue}>
                                    {item.teamScore}
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={5}>
                                    {t('totalScore')}
                                </Grid>
                                <Grid item xs={7} className={classes.parameterValue}>
                                    {item.totalScore}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            </Collapse>
        </div>

    );
}

const useStyles = makeStyles({
    container: {
        color: theme.primaryColor,
        '&:nth-child(even)': {
            backgroundColor: theme.lightPrimaryColor
        },
        margin: 0,
        fontSize: '0.9rem',
        fontWeight: 500,
        padding: '0.5rem 0',
    },
    race: {
        margin: "2rem 1rem"
    },
    cell: {
        overflowX: 'auto',
        display: "flex",
        alignItems: "center"
    },
    info: {
        marginTop: '0.2rem',
        fontSize: '0.75rem',
        '&>div': {
            padding: '0.2rem 0',
        }
    },
    notFinished: {
        background: "#eeeeee"
    },
    parameters: {
        marginTop: '0.2rem',
        fontSize: '0.75rem',
        '&>div': {
            padding: '0.2rem 0',
        }
    },
    clubLogo: {
        maxHeight: '2.5rem',
        maxWidth: '100%'
    },
    clubLogoCell: {
        overflowX: 'auto',
        padding: 0
    },
    clubLogoTeamCell: {
        display: "flex",
        flexAlign: "center",
        justifyContent: "space-between",
        height: "2rem",
        marginBottom: "1rem"
    },
    clubLogoTeam: {
        maxHeight: '2rem',
        maxWidth: '10rem',
        marginRight: "1rem"
    },
    teamResultCell: {
        marginBottom: "1rem"
    },
    crown: {
        width: '1.5rem',
        height: '1.5rem',
        marginRight: "0.5rem"
    },
    centeredRow: {
        display: 'flex',
        alignItems: 'center',
        padding: '0.5rem 0',
        flexDirection: 'row',
      },
    parametersBlock: {
        marginTop: "0.5rem",
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    parametersMore: {
        marginBottom: '1rem'
    },
    parameterValue: {
        fontSize: '0.8rem'
    },
})